var React = require('react');

function PasteInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"paste_24px"},React.createElement("path",{"id":"icon/content/paste_24px","fillRule":"evenodd","clipRule":"evenodd","d":"M39.5833 6.24999H30.875C30 3.83333 27.7083 2.08333 25 2.08333C22.2917 2.08333 20 3.83333 19.125 6.24999H10.4167C8.125 6.24999 6.25 8.12499 6.25 10.4167V43.75C6.25 46.0417 8.125 47.9167 10.4167 47.9167H39.5833C41.875 47.9167 43.75 46.0417 43.75 43.75V10.4167C43.75 8.12499 41.875 6.24999 39.5833 6.24999ZM25 6.24999C26.1458 6.24999 27.0833 7.18749 27.0833 8.33333C27.0833 9.47916 26.1458 10.4167 25 10.4167C23.8542 10.4167 22.9167 9.47916 22.9167 8.33333C22.9167 7.18749 23.8542 6.24999 25 6.24999ZM10.4167 10.4167V43.75H39.5833V10.4167H35.4167V16.6667H14.5833V10.4167H10.4167Z","fill":"white"})));
}

PasteInline.defaultProps = {"width":"50","height":"50","viewBox":"0 0 50 50","fill":"none"};

module.exports = PasteInline;

PasteInline.default = PasteInline;
